import { XStack } from 'tamagui';

export default XStack;
